import { Tag } from 'antd';
import React from 'react';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';

const BounceRateFormatter = ({ row }) => {
  const rate = row?.bounce_rate ?? 0;

  let colorClass = 'text-green';
  if (rate >= 20 && rate <= 80) {
    colorClass = 'text-gray';
  } else if (rate > 70) {
    colorClass = 'text-red';
  }

  return (
    <Tag bordered={false} className='w-fit'>
      <span className={`text-center text-sm font-bold w-full ${colorClass}`}>
        {getFormattedNumber(rate)}%
      </span>
    </Tag>
  );
};

export default BounceRateFormatter;
